import trustedClients from "../../constants/trusted-clients";

function ClientCard({ client }) {
  return (
    <a href={client.link} target="_blank" rel="noopener noreferrer" className="group flex flex-col items-center gap-3">
      <div className="flex h-24 w-44 items-center justify-center rounded-2xl border border-gray-100 bg-white p-4 shadow-sm transition-all group-hover:-translate-y-1 group-hover:shadow-md">
        <img
          src={client.logo}
          alt={client.name}
          className="h-16 w-36 object-contain"
          onError={(e) => {
            e.target.style.display = "none";
            e.target.nextSibling.style.display = "block";
          }}
        />
        <span className="hidden text-sm font-medium text-gray-600">{client.name}</span>
      </div>
      <span className="text-xs font-medium text-gray-500 tracking-wide uppercase group-hover:text-purple-600 transition-colors">
        {client.name}
      </span>
    </a>
  );
}

export default function TrustedClients() {
  if (trustedClients.length === 0) return null;

  return (
    <section className="bg-white py-14 md:py-16">
      <div className="max-w-6xl mx-auto px-4 sm:px-5">
        <div className="text-center mb-10">
          <p className="text-sm font-medium uppercase tracking-widest text-purple-600 mb-2">Trusted By</p>
          <h2 className="text-2xl md:text-3xl text-gray-900">Brands That Trust Parcelin</h2>
        </div>
        {trustedClients.length <= 5 ? (
          <div className="flex flex-wrap justify-center items-start gap-6 md:gap-8">
            {trustedClients.map((client) => (
              <ClientCard key={client.name} client={client} />
            ))}
          </div>
        ) : (
          <div className="overflow-hidden">
            <style>{`
              @keyframes marquee {
                0% { transform: translateX(0); }
                100% { transform: translateX(-50%); }
              }
              .marquee-track { animation: marquee 30s linear infinite; }
              .marquee-track:hover { animation-play-state: paused; }
              @media (prefers-reduced-motion: reduce) { .marquee-track { animation: none; } }
            `}</style>
            <div className="flex marquee-track" style={{ width: "max-content" }}>
              {[...trustedClients, ...trustedClients].map((client, index) => (
                <div key={`${client.name}-${index}`} className="mx-4">
                  <ClientCard client={client} />
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </section>
  );
}
